import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select, Row, Col, Input, Button } from "antd";
import { RootState } from "reducers/rootReducer";
import { formatForRedis } from "utils/appUtil";
import TimeInput from "../TimeInput";
import DateInput from "../DateInput";
import NumberInput from "../NumberInput";

const { Option } = Select;

const FareTypeInput = (props: any) => {
  const { value, placeholder, onChange, dispatchOptions, disabled } = props;
  const [options, setOptions] = useState(
    dispatchOptions || [
      { id: "fixed", name: "Fixed" },
      { id: "variable", name: "Variable" },
    ]
  );

  return (
    <React.Fragment>
      {/* <Select
        showSearch
        value={value?.value}
        className="w-full"
        placeholder={placeholder}
        disabled={disabled}
        onChange={(value) => {
          onChange({
            value,
            type: "fareType",
          });
        }}
        filterOption={(input, option) =>
          (option!.children as unknown as string)
            .toLowerCase()
            .includes(input.toLowerCase())
        }
      >
        {options?.map((option, index) => (
          <Option key={index} value={option.id}>
            {option.name}
          </Option>
        ))}
      </Select> */}

      <div className="tiles padding-12">
        {/* <span className="col-label">{data?.label}</span> */}
        <Row className="">
          <Col span={6} className="d-flex align-items-center">
            {/* <h5 className="mb-0">Dispatch type</h5> */}
            <span className="col-label">Fare type</span>
          </Col>
          {options?.map((option, index) => (
            <Col span={6}>
              <Button
                disabled={disabled}
                onClick={() => {
                  onChange({
                    value: option.id,
                    type: "fareType",
                  });
                }}
                className={`beam-btn ${
                  value?.value === option.id ? "green-btn cover" : ""
                }`}
              >
                {option.name}
              </Button>
            </Col>
          ))}
        </Row>

        {value && value?.value === "fixed" && (
          <Row className="mt-3">
            <Col span={24}>
              <NumberInput
                disabled={disabled}
                placeholder="Fixed price"
                value={value?.fare}
                onChange={(fare) => {
                  console.log("fare", fare);
                  onChange({
                    value: value?.value,
                    type: "fareType",
                    fare: fare,
                  });
                }}
              />
            </Col>
          </Row>
        )}
      </div>
    </React.Fragment>
  );
};

export default FareTypeInput;
